import { render } from "./AppSubmenu.vue?vue&type=template&id=af75bf1a"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\9consulting-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__